import MmenuLight from "mmenu-light/src/mmenu-light";

export function initMobileMenu() {
  console.debug("Lade MobileMenu.");
  var element = document.querySelector("#menu");

  console.debug(element);

  if (!element) return;

  const menu = new MmenuLight(element as HTMLElement, "(max-width: 1024px)");

  const navigator = menu.navigation({
    // options
  });

  const drawer = menu.offcanvas({
    // options
  });

  document
    .querySelector('a[href="#menu"]')
    ?.addEventListener("click", (evnt) => {
      console.log("click!");
      evnt.preventDefault();
      drawer.open();
    });
}
